<hr style="margin-top: 48px;margin-bottom: 48px;">
<h1 class="mat-h1" style="margin-top: 48px;margin-bottom: 48px;text-align: center;font-weight: bold;color: red;">Verifica OTP in corso...</h1>
<hr style="margin-top: 48px;margin-bottom: 48px;">
